<template>
  <div>
  <div class="page-title">
      <div class="container">
        <h1><strong> Paiement rapide </strong></h1>
        <ul class="breadcrumbs">
          <li><router-link to="/"><strong> Home </strong></router-link>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li><strong> Paiement rapide </strong></li>
        </ul>
      </div>
  </div>

    <div class="container padding-bottom-3x mb-2">
      <div class="row">
        <!-- Checkout Address-->
        <div class="col-xl-9 col-lg-8">
          <h4><strong> Remplissez votre numéro de téléphone </strong></h4>
          <hr class="padding-bottom-1x">

          <form>


          <div class="row">

            <div v-if="!isAuthenticated" class="col-sm-6">

              <div class="form-group">
                <label for="phone"><strong>Téléphone portable: *</strong></label>
                <label for="phone"><strong>رقم الهاتف</strong></label>
                <input v-validate="{required:true, regex:/^[0]([5-6-7]{1}[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2})$/ }" class="form-control" name="phone" type="number" v-model="phoneNumber">
                <span class="alert-box alert-danger">{{errors.first('phone')}}</span>
              </div>
            </div>
          </div>

          </form>

          <hr class="padding-bottom-1x">
          <div class="d-flex justify-content-between">
          <router-link class="btn btn-outline-secondary m-0" to="/cart"><strong> Retour </strong></router-link>
          <router-link class="btn btn-primary m-0" to="/payment" @click.native ="user_info(phoneNumber)" :disabled="!isComplete"><strong> Valider </strong></router-link></div>
        </div>

        <!-- Sidebar          -->
        <div class="col-xl-3 col-lg-4">
          <aside class="sidebar">
            <div class="padding-top-2x hidden-lg-up"></div>
            <!-- Order Summary Widget-->
            <section class="widget widget-order-summary bg-secondary border-0 p-4">
              <h3 class="widget-title"><strong> Récapitulatif de la commande </strong></h3>
              <table class="table text-sm mb-0">
                <tr>
                  <td><strong> Total: </strong> </td>
                  <td class="text-medium"> <strong> {{total}} DA </strong></td>
                </tr>
                <tr>
                  <td><strong> frais de livraison: </strong></td>
                  <td class="text-medium"><strong> 0.00 DA </strong></td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-lg text-medium"><strong> {{total}} DA </strong></td>
                </tr>
              </table>
            </section>
            <!-- Featured Products Widget-->

            <!-- Promo Banner-->
            <!--<div class="fw-section mt-1 px-4 py-5 text-center" style="background-image: url(static/img/banners/alert-bg.jpg);">
              <h3 class="text-white">Check our <br><span class='text-bold'>Latest Offers.</span><br> Save up to <span class='text-bold'>50%</span></h3><a class="btn btn-primary btn-sm" href="#">View Offers</a>
            </div>
            -->
          </aside>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapGetters, mapActions } from 'vuex';
export default {
  computed: {
    isComplete (){
      return this.phoneNumber
    },
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    },
    ...mapGetters({ products: 'cartProducts', isAuthenticated: 'isAuthenticated' }),
    ...mapActions(['user_info']),
    ...mapFields([
      'commandeInfo.phoneNumber',

    ])
  }
};

</script>



<style scoped>
/*.form-group label {
  text-transform: none;
}*/
.page-title {
  margin-top: 1.5em;
}
</style>






// WEBPACK FOOTER //
// src/components/checkout/checkadress.vue